import React from 'react';
const COLORS = {
  green: 'rgb(0, 255, 0)',
  yellow: 'rgb(255, 255, 0)',
  red: 'rgb(251, 87, 98)',
  grey: 'rgb(176, 176, 176)',
  orange: 'rgb(236, 148, 42)',
  purple: 'rgb(27, 21, 98)',
  black: 'rgb(51, 51, 51)',
  pending: 'rgb(241, 196, 164)',
};
const BACKGROUND_COLORS = {
  green: 'rgba(0, 255, 0,.1)',
  yellow: 'rgba(255, 255, 0,.1)',
  red: 'rgba(251, 87, 98,.1)',
  grey: 'rgba(176, 176, 176,.1)',
  orange: 'rgba(236, 148, 42,.1)',
  purple: 'rgba(27, 21, 98,.1)',
  black: 'rgba(51, 51, 51,.1)',
  pending: 'rgba(241, 196, 164,.1)',
};

const ColorComponent = (props) => {
  const { value } = props;

  let valueToShow = value;
  let selectedBackgroundColor = BACKGROUND_COLORS.grey;
  let selectedColor = COLORS.grey;
  if (value === 'WITHDRAW') {
    selectedColor = COLORS.red;
    selectedBackgroundColor = BACKGROUND_COLORS.red;
  } else if (value === 'DEPOSIT') {
    selectedColor = COLORS.purple;
    selectedBackgroundColor = BACKGROUND_COLORS.purple;
  } else if (value === 'INIT') {
    selectedColor = COLORS.orange;
    selectedBackgroundColor = BACKGROUND_COLORS.orange;
  } else if (value === 'PENDING') {
    selectedColor = COLORS.pending;
    selectedBackgroundColor = BACKGROUND_COLORS.pending;
  } else if (value === 'VERIFIED') {
    selectedColor = COLORS.green;
    selectedBackgroundColor = BACKGROUND_COLORS.green;
  } else if (value === 'Active') {
    selectedColor = COLORS.green;
    selectedBackgroundColor = BACKGROUND_COLORS.green;
  } else if (value === 'InActive') {
    selectedColor = COLORS.red;
    selectedBackgroundColor = BACKGROUND_COLORS.red;
  } else if (value === 'APPROVED') {
    selectedColor = COLORS.green;
    selectedBackgroundColor = BACKGROUND_COLORS.green;
  } else if (value === 'NOT SUBMITTED') {
    selectedColor = COLORS.red;
    selectedBackgroundColor = BACKGROUND_COLORS.red;
  } else {
    selectedColor = COLORS.black;
    selectedBackgroundColor = BACKGROUND_COLORS.black;
  }
  if (value === true) {
    selectedColor = COLORS.green;
    selectedBackgroundColor = BACKGROUND_COLORS.green;
    valueToShow = 'Active';
  }
  if (value === false) {
    selectedColor = COLORS.red;
    selectedBackgroundColor = BACKGROUND_COLORS.red;
    valueToShow = 'InActive';
  }
  return (
    <div
      style={{
        backgroundColor: selectedBackgroundColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        padding: '5px 15px',
        width:"max-content"
      }}
    >
      <p
        style={{
          margin: 0,
          padding: 0,
          color: selectedColor,
          // fontSize: "16px",
          fontWeight: '800',
        }}
      >
        {valueToShow}
      </p>
    </div>
  );
};

export default ColorComponent;
